module.exports = __webpack_public_path__ + "3a8be7acd94a11760707d5374bea1f6d.svg";